// Courses reducer types
export const SET_ALL_COURSES = 'SET_ALL_COURSES';
export const SET_ONE_COURSE = 'SET_ONE_COURSE';
export const SET_ONE_LESSON = 'SET_ONE_LESSON';
export const SET_COURSE_LESSONS = 'SET_COURSE_LESSONS';
export const SET_COURSES_OVERVIEW = 'SET_COURSES_OVERVIEW';
export const JOIN_COURSE = 'JOIN_COURSE';
export const LEAVE_COURSE = 'LEAVE_COURSE';
export const POST_FILE = 'POST_FILE';
export const DELETE_FILE = 'DELETE_FILE';
export const LIKE_FILE = 'LIKE_FILE';
export const UNLIKE_FILE = 'UNLIKE_FILE';
export const SUBMIT_COMMENT = 'SUBMIT_COMMENT';
export const CREATE_COURSE = 'CREATE_COURSE';
export const CREATE_LESSON = 'CREATE_LESSON';
export const UPDATE_COURSE = 'UPDATE_COURSE';
